<template>
	<canvas id="canvas"></canvas>
	<canvas id="layer"></canvas>
	<div class="flex w-full flex-col items-center justify-center">
		<img src="/img/logo.png" class="mb-8 w-[240px]" />
		<div class="cardBox" :class="{ active: activeCard }">
			<div class="cardBox_first"></div>
			<div class="card">
				<p class="text-center text-[28px]">ログイン</p>

				<p class="mt-12 text-[14px] font-normal">
					アカウントの発行は開発TEAMまでご連絡ください。
				</p>

				<div class="mt-8 w-full">
					<InputForm
						v-model="formData.email"
						:type="'text'"
						:title="'メールアドレス'"
						:text="''"
						:required="false"
						:disabled="false"
						:form-class="'w-full'"
						:maxlength="255"
						:placeholder="'test@gmail.com'"
						:error-text="errors.email"
					/>
				</div>

				<div class="mt-8 w-full">
					<PasswordForm
						v-model="formData.password"
						:title="'パスワード'"
						:required="false"
						:disabled="false"
						:form-class="'w-full'"
						:maxlength="20"
						:error-text="errors.password"
					/>
				</div>

				<div class="mt-4 text-left">
					<router-link to="/password_forgot" class="textLink">
						パスワードをお忘れの方<i
							class="fa-solid fa-arrow-right fa-fw fa-lg"
						/>
					</router-link>
				</div>

				<div class="mt-12 flex justify-center">
					<Button
						:button-type="'submit'"
						:button-class="''"
						:button-icon="'fa-right-to-bracket'"
						:button-text="'ログイン'"
						@click="login"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import InputForm from "@/components/molecules/form/InputForm.vue";
import PasswordForm from "@/components/molecules/form/PasswordForm.vue";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
//store
import { useAuthStore } from "@/stores/AuthStore";
import { usePartsStore } from "@/stores/PartsStore";
// utils
import bgAnimaion from "@/utils/BgAnimaion.js";
import toaster from "@/utils/Toaster.js";
// api
import FunctionApi from "@/api/FunctionApi.js";

const authStore = useAuthStore();
const partsStore = usePartsStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
	router
---------------------------------------------------------------------------- */
const router = useRouter();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { alert } = toaster();
const { animation } = bgAnimaion();
/* ---------------------------------------------------------------------------
	data
---------------------------------------------------------------------------- */
const activeCard = ref(false);
const formData = ref({
	email: "",
	password: ""
});
const errors = ref([]);
const errorText = ref("");
/* ---------------------------------------------------------------------------
	methods
---------------------------------------------------------------------------- */

function cardChange() {
	activeCard.value = !activeCard.value;
}
/* ---------------------------------------------------------------------------
	通常のログイン
---------------------------------------------------------------------------- */
async function login() {
	axios.get("/sanctum/csrf-cookie").then(response => {
		functionApi.auth.signIn(formData.value).then(res => {
			errors.value = [];
			errorText.value = "";

			// trueならダッシュボードページに遷移
			if (res.result) {
				alert("login");

				authStore.isAuthenticated = true;
				authStore.user = res.data;

				partsStore.detailLoader = true;

				setTimeout(() => {
					partsStore.detailLoader = false;

					// KIZUNAの管理画面選択に遷移
					router.push("/mgmt_select");
				}, 1500);
				// falseならエラー表示
			} else {
				alert("error_login");

				partsStore.detailLoader = false;
				if (res.errors[0] == "EMAILかPASSWORDが間違えています") {
					errorText.value = res.errors[0];
				}
				errors.value = res.errors;
			}
		});
	});
}
onMounted(() => {
	// animation();
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.cardBox {
	position: relative;
	width: 100%;
	min-width: 480px;
	max-width: 480px;
}
.cardBox_first {
	background: $bg-white1;
	height: 10px;
	border-radius: 5px 5px 0 0;
	margin: 0 10px;
	padding: 0;
}

.card {
	position: relative;
	background: $bg-white2;
	border-radius: 5px;
	padding: 60px 40px 40px;
	box-sizing: border-box;
	@include boxShadow(0.15);
	@include trans(0.3);
}
.cardBox.active .card:first-child {
	background: #f2f2f2;
	margin: 0 15px;
}
.cardBox.active .card:nth-child(2) {
	background: #fafafa;
	margin: 0 10px;
}
.card_border {
	display: flex;
	align-items: center;
}
.card_border:before {
	margin-right: 2rem;
}
.card_border:after {
	margin-left: 2rem;
}
.card_border:before,
.card_border:after {
	content: "";
	height: 1px;
	flex-grow: 1;
	background-color: #ddd;
}
#layer {
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100%;
	z-index: -1;
	background: $bg-white2;
	@include backdropFilter(5px);
	@include glassmorphism(0.2);
}
#canvas {
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100%;
	z-index: -2;
	// background-image: url("/img/main_bg.png");
	background-repeat: no-repeat;
	background-position: center;
	background-size: 800px;
}
</style>
